
import {getActDetail} from '../../services/api'

const activity = {
  state: {
    actDetail: []
  },
  mutations: {
    setActDetail (state, data) {
      state.actDetail = data;
    },
  },
  actions: {
    ajaxActDetail ({ commit }, data) {
      var params = data;
      return new Promise((resolve, reject) => {
        getActDetail(params).then((response) => {
          var result = response.data;
          if(result.status == 1){
            commit('setActDetail', result.data);
            resolve(result.data);
          }
        }).catch((error) => {
          reject(error);
        });
      })
    }
  },
  getters: {
    
  }
}

export default activity